import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import PWAInstallPrompt from 'pwa-install-prompt'

Vue.config.productionTip = false

/*
const fixIdScrolling = {
  watch: {
    $route (to, from) {
      const currentRoute = this.$router.currentRoute
      const idToScrollTo = currentRoute.hash
      this.$nextTick(() => {
        if (idToScrollTo && document.querySelector(idToScrollTo)) {
          document.querySelector(idToScrollTo).scrollIntoView()
        }
      })
    }
  }
}
*/

new Vue({
  // mixins: [fixIdScrolling],
  router,
  render: h => h(App)
}).$mount('#app')

// PWA prompt for Safari
/* eslint-disable no-new */
require('../node_modules/pwa-install-prompt/style.css')
new PWAInstallPrompt()
